import { PocComponentHeader } from 'commons/components/components-wrapper/poc-component-header.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { Select, SelectPropsValue } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { DeviceTypeDetails, DeviceTypeOperatorListOptions } from 'modules/devices/domain/api/device-type.api';
import React from 'react';
import { DeviceCardStyled } from './device-card.style';

interface DeviceCardComponentProps {
    deviceTypeDetails: DeviceTypeDetails;
    options?: { value: DeviceTypeOperatorListOptions; text: string }[];
    onChangeOperatorsListOption?: (field: string, value: SelectPropsValue) => void;
}

export const DeviceCardComponent: React.FC<DeviceCardComponentProps> = (props) => {
    const { deviceTypeDetails, options, onChangeOperatorsListOption } = props;

    const { t } = useTranslation();

    return (
        <DeviceCardStyled rounded className="no-border">
            <div slot="header">
                <PocComponentHeader>{deviceTypeDetails.name}</PocComponentHeader>
            </div>
            <div className="device-card-content">
                {deviceTypeDetails.supportOperatorsList ? (
                    <>
                        <Select
                            name="operatorsListMode"
                            className="inline"
                            label={'settings.devices.device-types.device.operators-list.label'}
                            required
                            options={options!}
                            value={deviceTypeDetails.operatorListMode}
                            onChange={onChangeOperatorsListOption!}
                        />
                        <PocTypography variant="subtitle1" element="h6">
                            {t('settings.devices.device-types.device.operators.max', {
                                number: deviceTypeDetails.maximumOperators,
                            })}
                        </PocTypography>
                    </>
                ) : (
                    <div className="block inline no-options">
                        <PocTypography element="span" variant="subtitle2">
                            {t('settings.devices.device-types.device.operators-list.label')}
                        </PocTypography>
                        <PocTypography element="p" variant="body2">
                            {t('settings.devices.device-types.device.operators-list.not-allowed')}
                        </PocTypography>
                    </div>
                )}
            </div>
        </DeviceCardStyled>
    );
};
